import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from '../analytics';

// Sends a $pageview on every route change. Lives inside the Router (like
// DeviceReporter) so it can read useLocation.
//
// Why manual: the app uses HashRouter on desktop (file://) and mobile
// (capacitor://), where PostHog's automatic pageview capture fires once at load
// with a useless file:// URL and never fires again on navigation. useLocation
// gives the real route on all three surfaces.
export default function AnalyticsTracker() {
  const location = useLocation();
  // React 18 StrictMode double-invokes effects in development; without this the
  // first pageview of a session would be sent twice.
  const lastPath = useRef(null);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (lastPath.current === key) return;
    lastPath.current = key;
    capturePageview(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
